import { EquipmentListContext } from 'app/components/ReactContexts/equipmentListContext';
import { MenuAndContent, SubmenuAndContent } from 'app/components/layouts';
import useFlag from 'app/hooks/useFlag';
import { EquipmentList } from 'app/pages/Equipment/EquipmentList';
import { EquipmentNotLoaded } from 'app/pages/Equipment/EquipmentNotLoaded';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { invitationsApi } from 'services/api/invitations/queries';
import { FeatureName } from 'types/entities/MobileSettings';

interface Props {
  submenu: JSX.Element;
}

export default function EquipmentEmptyStateLayout({ submenu }: Props) {
  const { equipmentListData } = React.useContext(EquipmentListContext);
  const isAccessSharingPageEnabled = useFlag(FeatureName.ACCESS_SHARING);

  const {
    data: invitations = {
      pendingReceivedInvitations: [],
      pendingSentInvitations: [],
    },
  } = invitationsApi.useGetInvitationsQuery(undefined, {
    skip: !isAccessSharingPageEnabled,
  });

  const renderContentOrEmptyState = (comp: JSX.Element) => {
    return !!equipmentListData?.equipmentList?.length ? (
      comp
    ) : equipmentListData?.equipmentList &&
      invitations.pendingReceivedInvitations.length ? (
      <SubmenuAndContent submenu={<EquipmentList />}>
        <EquipmentNotLoaded />
      </SubmenuAndContent>
    ) : (
      <MenuAndContent>
        <EquipmentNotLoaded />
      </MenuAndContent>
    );
  };

  return renderContentOrEmptyState(
    <SubmenuAndContent submenu={submenu}>
      <Outlet />
    </SubmenuAndContent>,
  );
}
